import React, {useState} from "react";
import axios from "axios";
import {SEARCH_URL} from "../api/constants";
import ApplicationStatus from "./ApplicationStatus";
import {Drawer} from "@material-ui/core";
import PatentDetails from "./PatentDetails";
import PatentSearchHeader from "./PatentSearchHeader";
import PatentSearchResults from "./PatentSearchResults";



const PatentSearch = () => {

    const [searchString, setSearchString] = useState(null)
    const [patents, setPatents] = useState([])
    const [extra, setExtra] = useState({})
    const [size,setSize] = useState(350)

    const [progress, setProgress] = useState(false)

    const [selectedPatentDetails, setSelectedPatentDetails] = useState(null)
    const [selectedApplicationStatus, setSelectedApplicationStatus] = useState(null)

    const search = ({search_string, page = null, extra = null}) => {
        setProgress(true)
        let params = {search_string}
        if (page) {
            params = {...params, page: page, ...extra}
        }
        console.log(params)
        axios.get(SEARCH_URL, {
            params
        }).then(res => {
            setPatents(res.data.dataset)
            setExtra(res.data.extra)
            setSearchString(search_string)
            setProgress(false)
        }).catch(err => {
            console.log(err)
            setProgress(false)
        })
    }

    const handleSearch = (queryString) => {
      var width=window.innerWidth
      if (width>648){
        setSize(900)
      }
      
        setPatents([])
        setExtra([])
        setSearchString(null)
        search({search_string: queryString})
    }

    const handleFetchPage = (page) => {
        if (!page) {
            return false
        }
        console.log(parseInt(extra.total_pages), page)
        if (1 <= page && page <= parseInt(extra.total_pages) && page !== parseInt(extra.current_page)) {
            search({search_string: searchString, page, extra})
        }
    }




    return (
        <div className='flex flex-col space-y-8 p-4'>
          
            <PatentSearchHeader handleSearch={handleSearch} progress={progress}/>
            {searchString && <PatentSearchResults openPatentDetails={setSelectedPatentDetails} openApplicationStatus={setSelectedApplicationStatus} patents={patents} extra={extra} handleFetchPage={handleFetchPage}/>}
            {/*<PatentSearch applicationNumber={}/>*/}
            <Drawer open={selectedPatentDetails}
              className=""
              anchor={"right"} onClose={()=>setSelectedPatentDetails(null)}>
                <div style={{width:size}} className=''>
                    <PatentDetails applicationNumber={selectedPatentDetails}/>
                </div>
            </Drawer>
            <Drawer open={selectedApplicationStatus} anchor={"right"} onClose={()=>setSelectedApplicationStatus(null)}>
                <div style={{width:size}} className='bg-white'>
                    <ApplicationStatus applicationNumber={selectedApplicationStatus}/>
                </div>
            </Drawer>
        </div>
    )
}

export default PatentSearch